import React from "react";
import { Document, Page, pdf, View } from "@react-pdf/renderer";
import Button from "@material-ui/core/Button";
import { GrDocumentPdf } from "react-icons/gr";
import TariffPdfData from "./tariffPdfData";
import PdfFooter from "./pdfFooter";
import PdfHeader from "./pdfHeader";

const TariffDownloadPdf = (props) => {
    const { pdfData, onDownloadPdf = () => { } } = props;

    const downloadFile = ({ filename, url }) => {

        let element = document.createElement("a");
        element.href = url;
        element.setAttribute("download", filename);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };

    const pdfdetails = (pdfSaveId) => {
        return <TariffPdfData tariffData={pdfData} pdfId={pdfSaveId} />
    }

    const downloadPDF = async () => {
        const data = await onDownloadPdf()
        if (data?.data?._id) {

            const details = await pdfdetails(data?.data?._id)
            const pdfBlob = await pdf(
                <Document>
                    <Page
                        size="A4"
                        orientation="portrait"
                        wrap={true}
                        style={{
                            paddingTop: 40,
                            paddingBottom: 60,
                            backgroundColor: '#FFFFFF'
                        }}
                    >
                        <View fixed style={{ position: 'absolute', top: 0, left: 0, right: 0 }}>
                            <PdfHeader />
                        </View>

                        {details}

                        <View fixed style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
                            <PdfFooter />
                        </View>

                    </Page>
                </Document>
            ).toBlob();

            const url = window.URL.createObjectURL(
                new Blob([pdfBlob], { type: "application/pdf" })
            );
            downloadFile({ filename: data?.pdfname, url });
        }
    };

    return (
        <div>
            <button
                className="h-[22px] px-2.5 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium flex items-center gap-1.5 border border-[#313C4C] rounded-none cursor-pointer transition-colors shadow-2xs"
                onClick={downloadPDF}
            >
                <GrDocumentPdf size={12} />
                <span>Download PDF</span>
            </button>
        </div>
    );
};

export default TariffDownloadPdf;
